import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import TrustBar from "@/pages/home/components/TrustBar";
import Services from "@/pages/home/components/Services";
import Advantages from "@/pages/home/components/Advantages";
import Coverage from "@/pages/home/components/Coverage";
import UseCases from "@/pages/home/components/UseCases";
import Onboarding from "@/pages/home/components/Onboarding";
import CtaBand from "@/pages/home/components/CtaBand";
import InquiryForm from "@/pages/home/components/InquiryForm";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <Advantages />
        <Coverage />
        <UseCases />
        <Onboarding />
        <CtaBand />
        <InquiryForm />
      </main>
      <Footer />
    </div>
  );
}